import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PackageShowcaseArt from "@/components/showcase/PackageShowcaseArt";
import { cn } from "@/lib/utils";

export default function PackageFeatureCard({
  to,
  title,
  tag,
  image,
  variant,
  layout = "wide",
  description,
  highlights = [],
  className,
  testId,
}) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={cn(
        "package-feature-card group",
        `package-feature-card--${layout}`,
        className,
      )}
    >
      <div className="package-feature-card__content">
        <p className="package-feature-card__tag">{tag}</p>
        <h3 className="package-feature-card__title">{title}</h3>
        {description ? (
          <p className="package-feature-card__description">{description}</p>
        ) : null}
        {highlights.length ? (
          <div className="package-feature-card__highlights">
            {highlights.map((item) => (
              <span key={item} className="package-feature-card__highlight">
                {item}
              </span>
            ))}
          </div>
        ) : null}
      </div>
      <div className="package-feature-card__visual">
        <PackageShowcaseArt image={image} variant={variant} layout={layout} />
      </div>
      <span className="package-feature-card__arrow">
        <ArrowUpRight size={14} className="arrow-nudge" />
      </span>
    </Link>
  );
}
